module.exports = __webpack_public_path__ + "static/2-1367324cc1fc8c88c6df62811c464512.jpg";